import { Routes } from '@angular/router';

import { SubscriptionComponent } from './subscription.component';

export const SUBSCRIPTION_ROUTES: Routes = [
    {
        path: 'subscribe',
        component: SubscriptionComponent,
        pathMatch: 'full'
    }
];
